module.exports = __webpack_public_path__ + "static/media/female_respiratory_system.98a6cfd1.png";